import { useLookbookProductsContext } from '@app/components/lookbook/context/LookbookProductsContext';
import { BREAKPOINTS } from '@app/constants/breakpoints';
import { useIsScreenSize } from '@app/utils/hooks';
import { isEmpty } from 'ramda';

import { FiltersPanel } from './FiltersPanel';
import { FiltersPanelMobile } from './FiltersPanelMobile';

interface Props {
  isDrawerOpen: boolean;
  onDrawerClose: () => void;
}

export const LookbookFiltersPanel = ({ isDrawerOpen, onDrawerClose }: Props) => {
  const isMobile = useIsScreenSize(BREAKPOINTS.SM);
  const {
    expandedFilters,
    setExpandedFilters,
    productAttributes,
    handleFilterChange,
    handleClearAllFilters,
    filters,
    isLoadingFilters,
    totalItems,
  } = useLookbookProductsContext();

  const handleToggleFilter = (fieldName: string, isExpanded: boolean) => {
    const newExpandedFilters = { ...expandedFilters, [fieldName]: !isExpanded };

    setExpandedFilters(newExpandedFilters);
  };

  if (isMobile) {
    return (
      <FiltersPanelMobile
        isDrawerOpen={isDrawerOpen}
        onDrawerClose={onDrawerClose}
        filters={filters}
        attributes={productAttributes}
        onFilterChange={handleFilterChange}
        isLoading={isLoadingFilters}
        hasActiveFilters={!isEmpty(filters)}
        itemsCount={totalItems}
        handleToggleFilter={handleToggleFilter}
        expandedFilters={expandedFilters}
        onClearFilters={handleClearAllFilters}
      />
    );
  }

  return (
    <FiltersPanel
      onDrawerClose={onDrawerClose}
      onClearFilters={handleClearAllFilters}
      isLoading={isLoadingFilters}
      itemsCount={totalItems}
      hasActiveFilters={!isEmpty(filters)}
      attributes={productAttributes}
      filters={filters}
      onFilterChange={handleFilterChange}
      handleToggleFilter={handleToggleFilter}
      expandedFilters={expandedFilters}
      hasHeaderBanner
      hasBreadcrumbs
    />
  );
};
